import { css } from "@emotion/react";
import styled from "@emotion/styled";
import ArrowLast from "@engineering/icons/arrow-last";
import ArrowNext from "@engineering/icons/arrow-next";
import Close from "@engineering/icons/close";
var Header = /*#__PURE__*/ styled("div", {
    target: "erz30p20"
})("position:relative;min-height:2.5rem;margin-bottom:0.625rem;");
var Title = /*#__PURE__*/ styled("b", {
    target: "erz30p21"
})("display:inline-block;padding:0.75rem 0 0.5rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;font-weight:400;line-height:1.125;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{max-width:18.5rem;}", function(param) {
    var customColor = param.customColor;
    return customColor && "color: ".concat(customColor, "; font-weight: 700;");
});
var Subtitle = /*#__PURE__*/ styled("p", {
    target: "erz30p22"
})("color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";font-size:1rem;");
var FormContainer = /*#__PURE__*/ styled("div", {
    target: "erz30p23"
})("width:505px;flex-grow:0;> *:not(:last-of-type){margin-bottom:0.625rem;}");
var StyledForm = /*#__PURE__*/ styled("form", {
    target: "erz30p24"
})("display:flex;flex-direction:row;aside{width:320px;flex-grow:1;}");
var ButtonWrapper = /*#__PURE__*/ styled("div", {
    target: "erz30p25"
})("button{margin:0.625rem 0;", function(param) {
    var customColor = param.customColor;
    return customColor && "background-color: ".concat(customColor, ";");
}, "}");
var FooterLink = /*#__PURE__*/ styled("div", {
    target: "erz30p26"
})("text-align:right;margin-bottom:0;a{", function(param) {
    var iconOnLeft = param.iconOnLeft;
    return iconOnLeft && "flex-direction: row-reverse;";
}, "}");
var getOptionsStyles = function(theme) {
    return /*#__PURE__*/ css("width:0.75rem;height:0.75rem;fill:", theme.color.primary, ";");
};
var OptionsOpenIcon = /*#__PURE__*/ styled(ArrowLast, {
    target: "erz30p27"
})(function(param) {
    var theme = param.theme;
    return getOptionsStyles(theme);
}, ";");
var OptionsCloseIcon = /*#__PURE__*/ styled(ArrowNext, {
    target: "erz30p28"
})(function(param) {
    var theme = param.theme;
    return getOptionsStyles(theme);
}, ";");
var CloseIcon = /*#__PURE__*/ styled(Close, {
    target: "erz30p29"
})("cursor:pointer;");
export { ButtonWrapper, FooterLink, FormContainer, Header, StyledForm, Subtitle, Title, OptionsOpenIcon, OptionsCloseIcon, CloseIcon };
